export const profilePicture =
{
    id: 0,
    img: 'https://i.imgur.com/IpoG8v2.jpg',
    alt: 'Foto de perfil de Lázaro Santos',
};

export const background =
{
    id: 0,
    img: 'https://i.imgur.com/uCM1b9G.png',
    alt: 'Software Architecture Abstract Art',
};

export const preview = [
    {
        id: 0,
        img: 'https://i.imgur.com/SN9gKfd.jpg',
        alt: 'Meu desktop pessoal',
    },
    {
        id: 1,
        img: 'https://i.imgur.com/ZcGdHwR.png',
        alt: 'Exemplos de landing pages e diagramas',
    },
    {
        id: 2,
        img: 'https://raw.githubusercontent.com/evitarafadiga/chuva-inc.github.io/refs/heads/main/src/public/preview.png',
        title: 'Site 13 Slaca',
        href: 'https://github.com/evitarafadiga/chuva-inc.github.io',
        alt: 'Réplica de site usando Svelte Kit + tailwindcss',
    },
    {
        id: 3,
        img: 'https://imgur.com/9s4vlGQ.png',
        title: 'Guarda-Roupas (Wardrobe)',
        href: 'https://imgur.com/9s4vlGQ.png',
        alt: 'Jogo Casi Castor Beta'
    },
    {
        id: 4,
        img: 'https://imgur.com/8korzKI.png',
        title: 'Japamala Casiando...',
        href: 'https://imgur.com/8korzKI.png',
        alt: 'Jogo Casi Castor Beta - Desenvolvimento avançado'
    },
    {
        id: 5,
        img: 'https://imgur.com/XC2rFFU.png',
        title: 'Reunião de castores',
        href: 'https://imgur.com/XC2rFFU',
        alt: 'Jogo Casi Castor Beta - Desenvolvimento avançado'
    },
    {
        id: 6,
        img: 'https://imgur.com/t4vdxoB.png',
        title: 'Alunos da Fábrica',
        href: 'https://imgur.com/t4vdxoB.png',
        alt: 'Projeto Fábrica de Programadores'
    },
    {
        id: 7,
        img: 'https://imgur.com/k4nKTJB.png',
        title: 'Sistema de partículas entre portais',
        href: 'https://imgur.com/k4nKTJB',
        alt: 'Magnitude Beta'
    }
];